import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next");
  const [form, setForm] = useState({ email: "", password: "", full_name: "", phone: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Hesabınız oluşturuldu!");
      navigate(next && next.startsWith("/") && !next.startsWith("//") ? next : "/hesabim");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Kayıt başarısız");
    } finally { setLoading(false); }
  };

  return (
    <div className="kz-container py-16 max-w-md">
      <h1 className="font-display text-3xl font-black mb-1">Kayıt Ol</h1>
      <p className="text-ink-500 mb-8">Yeni hesap oluşturun</p>
      <form onSubmit={submit} className="kz-card p-6 space-y-4">
        <label className="block">
          <span className="text-sm font-semibold mb-1 block">Ad Soyad</span>
          <input data-testid="register-name" required value={form.full_name} onChange={(e)=>setForm({...form, full_name: e.target.value})}
            className="w-full border border-ink-200 px-3 py-2.5 outline-none focus:border-ink-900"/>
        </label>
        <label className="block">
          <span className="text-sm font-semibold mb-1 block">E-posta</span>
          <input data-testid="register-email" type="email" required value={form.email} onChange={(e)=>setForm({...form, email: e.target.value})}
            className="w-full border border-ink-200 px-3 py-2.5 outline-none focus:border-ink-900"/>
        </label>
        <label className="block">
          <span className="text-sm font-semibold mb-1 block">Telefon</span>
          <input value={form.phone} onChange={(e)=>setForm({...form, phone: e.target.value})}
            className="w-full border border-ink-200 px-3 py-2.5 outline-none focus:border-ink-900"/>
        </label>
        <label className="block">
          <span className="text-sm font-semibold mb-1 block">Şifre</span>
          <input data-testid="register-password" type="password" required minLength={6} value={form.password} onChange={(e)=>setForm({...form, password: e.target.value})}
            className="w-full border border-ink-200 px-3 py-2.5 outline-none focus:border-ink-900"/>
        </label>
        <button data-testid="register-submit" disabled={loading} className="kz-btn-primary w-full">
          {loading ? "Hesap oluşturuluyor..." : "Hesap Oluştur"}
        </button>
        <div className="text-sm text-center text-ink-500 pt-2 border-t border-ink-200">
          Zaten üye misiniz? <Link to="/giris" className="text-brand font-semibold hover:underline">Giriş Yap</Link>
        </div>
      </form>
    </div>
  );
}
